import { useSelector } from "react-redux";

export const usePresetsData = () => {
  return useSelector((store) => {
    return store.CreativeAnalytics.presetsData;
  });
};
